import PostAuditingToolReportActionTypes from './post-auditing-tool-report.types';

/** ***************** GET POST AUDITING TOOL REPORT START *********************** */
export const fetchPostAuditingToolReportStart = (getData: any) => ({
	type: PostAuditingToolReportActionTypes.GET_POST_AUDITING_TOOL_REPORT_LIST_START,
	payload: getData,
});

export const getPostAuditingToolReportDetailsSuccess = (successData: any) => ({
	type: PostAuditingToolReportActionTypes.GET_POST_AUDITING_TOOL_REPORT_LIST_SUCCESS,
	payload: successData,
});

export const getPostAuditingToolReportDetailsFailure = (failureData: any) => ({
	type: PostAuditingToolReportActionTypes.GET_POST_AUDITING_TOOL_REPORT_LIST_FAILURE,
	payload: failureData,
});

export const fetchPostAuditingToolReportDetailsResponseResetStart = () => ({
	type: PostAuditingToolReportActionTypes.GET_POST_AUDITING_TOOL_REPORT_LIST_RESPONSE_RESET,
});

export const getPostAuditingToolReportDetailsResponseChanged = () => ({
	type: PostAuditingToolReportActionTypes.GET_POST_AUDITING_TOOL_REPORT_LIST_RESPONSE_CHANGED,
});
/** ***************** GET POST AUDITING TOOL REPORT END *********************** */

/** ***************** FETCH POST AUDITING TOOL REPORT EXCEL DETAILS START *********************** */
export const fetchPostAuditingToolReportExcelStart = (addData: any) => ({
	type: PostAuditingToolReportActionTypes.GET_POST_AUDITING_TOOL_REPORT_EXCEL_START,
	payload: addData,
});

export const fetchPostAuditingToolReportExcelSuccess = (successData: any) => ({
	type: PostAuditingToolReportActionTypes.GET_POST_AUDITING_TOOL_REPORT_EXCEL_SUCCESS,
	payload: successData,
});

export const fetchPostAuditingToolReportExcelFailure = (failureData: any) => ({
	type: PostAuditingToolReportActionTypes.GET_POST_AUDITING_TOOL_REPORT_EXCEL_FAILURE,
	payload: failureData,
});

export const fetchPostAuditingToolReportResponseExcelResetStart = () => ({
	type: PostAuditingToolReportActionTypes.GET_POST_AUDITING_TOOL_REPORT_EXCEL_RESPONSE_RESET,
});

export const fetchPostAuditingToolReportResponseExcelResetChanged = () => ({
	type: PostAuditingToolReportActionTypes.GET_POST_AUDITING_TOOL_REPORT_EXCEL_RESPONSE_CHANGED,
});

/** ***************** FETCH POST AUDITING TOOL REPORT EXCEL DETAILS END *********************** */
